import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import LinkIcon from "../../images/link.svg"

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

const Navigation = styled.ul`
  list-style: none;
  padding: 0;
      margin: 0rem 0 4rem 0;
  a {
    // font-size: 14px;
    font-family: ${(props) => props.theme.fontCondensed};
    line-height: 1;
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;
    // margin: 0.25rem;
    border-bottom: 1px solid transparent;
    transition: 0.2s;
    
    //&:hover,
    &[aria-current="page"],
    &.active {
      //border-bottom: 2px solid ${(props) => props.theme.colors.secondary};
    }
    ul {
      padding: 0;
      width: 100px;
      border-bottom: 2px solid ${(props) => props.theme.colors.primary};
      padding-bottom: 2.5rem;
      &:hover {
        padding-bottom: 2.3rem;
        transition: all 0.1s ease-in-out;
      }
      transition: all 0.2s ease-in-out;
      li {
        margin: 0;
        display: block;
        padding-bottom: 0.3rem;
        :first-child {
          font-size: 0.6rem;
        }
        :last-child {
          font-size: 1rem;
          font-family: ${(props) => props.theme.fontBold};
        }
      }
    }
    
  }
  a.grow {
    position: relative;
  }
  a.grow:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -4px;
    left: 0;
    background-color: ${(props) => props.theme.colors.secondary};
    visibility: hidden;
    width: 0;
    transition: all 0.2s ease-in-out;
  }
  a.grow:hover:before {
    visibility: visible;
    width: 100%
  }
  a.grow.active:before {
    visibility: visible;
    width: 100%
  }
  li {
    display: inline-block;
    margin: 0 1.5rem;
    // &:last-child {
    //   margin-right: 0;
    // }
  }
`;

const AccordionContent = styled.div`
    .accordion {
        //border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        padding-top: 2rem;
    }

    .accordion__item {
        border-bottom: 2px solid ${(props) => props.theme.colors.white};
    }

    .accordion__button {
      color: ${(props) => props.theme.colors.white};
      font-family: ${(props) => props.theme.fontTurmoil};
      cursor: pointer;
      padding: 1rem 0 1rem;
      text-align: left;
      border: none;
      text-transform: uppercase;
      font-size: 1.5rem;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
        font-size: 1rem;
      }
      :focus {
        outline: 0;
      }
    }

    

    .accordion__button:after {
        content: "";
        width: 20px;
        height: 20px;
        background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M75,5C36.3,5,5,36.3,5,75s31.3,70,70,70s70-31.3,70-70S113.7,5,75,5z M75,102.3L46.1,57.6h57.8L75,102.3z'/%3E%3C/svg%3E");
        top: 4px;
        float: right;
        display: inline-block;
        position: relative;
    }

    .accordion__button[aria-expanded='true']::after,
    .accordion__button[aria-selected='true']::after {
        background-image: url("data:image/svg+xml,%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23D33D17;%7D%0A%3C/style%3E%3Cpath class='st0' d='M75,5C36.3,5,5,36.3,5,75s31.3,70,70,70s70-31.3,70-70S113.7,5,75,5z M46.1,92.4L75,47.7l28.9,44.8L46.1,92.4 L46.1,92.4z'/%3E%3C/svg%3E");
    }

    [hidden] {
        display: none;
    }

    .accordion__panel {
        
        animation: fadein 0.35s ease-in;
    }

    /* -------------------------------------------------- */
    /* ---------------- Animation part ------------------ */
    /* -------------------------------------------------- */

    @keyframes fadein {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
`

const MenuMobile = () => {
  return (
    <nav>
      <Navigation>
        <li>
          <Link to="/about" className="" activeClassName="active">
            <ul>
              <li className="hide">106 YEAR HISTORY</li>
              <li>About</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/visiting" className="" activeClassName="active"> 
            <ul>
              <li className="hide">MAPS &amp; TRAVEL</li>
              <li>Visiting</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/spaces" className="" activeClassName="active">
            <ul>
              <li className="hide">APPLY / HIRE</li>
              <li>Spaces</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/trader-directory" className="" activeClassName="active" partiallyActive={true}>
            <ul>
              <li className="hide">DIRECTORY</li>
              <li>Traders</li>
            </ul>
          </Link>
        </li>
        <li>
          <Link to="/news" className="" activeClassName="active" partiallyActive={true}>
            <ul>
              <li className="hide">NEWS &amp; EVENTS</li>
              <li>What’s On</li>
            </ul>
          </Link>
        </li>
        <li>
            <Link to="/future/" className="" activeClassName="active" partiallyActive={true}>
            <ul>
                <li className="hide">CONSULTATION</li>
                <li>The Future</li>
            </ul>
          </Link>
        </li>
      </Navigation>
    </nav>
  )
}

export default MenuMobile
